import React from "react";
import MainConvert from "../Components/Converter";

const Converter = () => {
	return <MainConvert />;
};

export default Converter;
